export var KEY = '/v1/account-statement';
export var ITEMS_PER_PAGE = 10;
export var ROW_TYPES = {
    SEARCH: 'Consulta',
    MONITOR: 'Monitoria',
    PAUSE: 'Pausa',
};
export var dateFormat = 'DD/MM/YYYY';
export var ranges = [30, 60, 90];
